import {useCallback, useEffect, useState} from 'react';
import {makeStyles} from "@material-ui/core";
import clsx from 'clsx';
import AnalyzeKeyMomentPopOut from '../../../../../atoms/creator/analyzeKeyMomentPopout';
import {addOverviewToAnalysisKeyMoment} from '../../../../../../store/actions/creator/analysis';
import UtilService from '../../../../../../helper/service';
import roles from '../../../../../../helper/roles';
import {useHistory} from 'react-router';
import {useDispatch, useSelector} from 'react-redux';

const useStyles = makeStyles(() => ({
  root: {
    width: 85,
    height: 85,
    borderRadius: 15,
    padding: 10,
    cursor: 'pointer',
  },
  badge: {
    width: 20,
    height: 20
  },
  valuePanel: {
    display: 'flex',
    alignItems: 'center'
  },
  value: {
    fontSize: 18,
    fontFamily: 'Spartan-extrabold',
    color: '#FFFFFF',
    marginTop: 2
  },
  text: {
    fontSize: 11,
    fontFamily: 'roboto-medium',
    color: '#FFFFFF',
  },
  textPanel: {
    minWidth: 65,
    marginTop: 10,
    display: 'flex',
    alignItems: 'center'
  },
  textSimple: {
    fontSize: 11,
    fontFamily: 'roboto-medium',
    color: '#FFFFFF',
  },
  title: {
    display: "block",
    marginBottom: "2px",
  },
  popover: {
    background: '#fff',
    width: 230,
    boxShadow: '0px 0px 10px #00000033',
    borderRadius: 10,
    marginTop: "-140px",
    position: 'absolute',
    marginLeft: 10,
    zIndex: 2
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0 0 -2px 12px'
  },
  modalTitle: {
    fontFamily: 'roboto-bold',
    color: '#606B76',
    fontSize: 14,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  modalCloseIcon: {
    width: 10,
    height: 10,
    background: 'transparent'
  },
  pane: {
    display: 'flex',
    flexDirection: 'row',
    color: '#8191A1',
    marginTop: 6
  },
  clipName: {
    margin: '40px 40px 40px 0'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#1DB859',
    fontSize: 12,
    margin: 0
  },
  highlightdiv: {
    margin: "10px 0px"
  },
  clock: {
    width: 12,
    height: 12,
    marginRight: 3
  },
  pencil: {
    width: 12,
    height: 12,
    marginRight: 5,
    marginLeft: 8,
  },
  name_index: {
    margin: '0 7px',
    fontSize: 18
  },
  label_index: {
    fontFamily: 'Spartan-bold',
    letterSpacing: 1.2,
    paddingTop: 4,
    textTransform: 'uppercase'
  },
  popperBadgeIcon: {
    width: 20,
    height: 20
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  btn: {
    marginTop: 18,
    marginLeft: 5,
    padding: '3px 4px 3px 4px',
    color: '#697683',
    fontFamily: 'roboto-regular',
    fontSize: 10,
    background: '#F0F0F0',
    borderRadius: 6,
    textTransform: 'none',
    '&:hover': {
      background: '#e7e5e5',
    },
    '& img': {
      marginRight: 3
    }
  },
  smallRow: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#8191A1',
  },
  timeLabel: {
    fontFamily: 'Spartan-extrabold',
    fontSize: 10,
    marginRight: 3
  },
  segmentWord: {
    fontFamily: 'Spartan-bold',
    fontSize: 8,
    textTransform: 'uppercase',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  label: {
    fontSize: 12,
    fontFamily: 'roboto-bold',
    color: '#697683',
    textAlign: 'left',
  },
  modalBadgeIcon: {
    width: 25,
    height: 25
  },
  btnOK: {
    height: 37,
    padding: '18px',
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
}));

interface IProps {
  item: any;
  immersion: any;
  safety: any;
  type: string;
  index: any;
  overviewAgendas: any;
  isMobile: boolean;
  openPopover: () => void;
}

const AgendaItem = (props: IProps) => {

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { analyseStart, cliped } = useSelector((state: any) => state.analysis);
  const { sessionData } = useSelector((state: any) => state.creatorExperienceManager);
  const session = sessionData['session'];
  const { item, immersion, safety, type, index, isMobile, openPopover } = props;
  const { session_type, session_length } = session;

  const [mainbgColor, setMainbgColor] = useState("");
  const [imgSrc, setImageSrc] = useState("");
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
  const [overlay, setOverlay] = useState(null);

  const getColor = (color: string) => {
    switch (color.toLowerCase()) {
      case 'green':
        return '#1CB858';
      case 'gray':
        return '#8191A1';
      case 'red':
        return '#ED554A';
      default:
        return '#8191A1';
    }
  };

  useEffect(() => {
    let color, testSrc = "";

    if (type === "immersion") {
      testSrc = immersion['overall_index'] === 0
        ? `/assets/icons/overview/red-${type}-badge.svg`
        : `/assets/icons/overview/${immersion['color_indicator'].toLowerCase()}-${type}-badge.svg`;
      color = immersion['overall_index'] === 0
        ? getColor('gray')
        : getColor(immersion['color_indicator']);
    } else if (type === "safety") {
      testSrc = (safety['overall_index'] === 1 || safety['overall_index'] === 0)
        ? `/assets/icons/overview/gray-${type}-badge.svg`
        : `/assets/icons/overview/${safety['color_indicator'].toLowerCase()}-${type}-badge.svg`;
      color = (safety['overall_index'] === 1 || safety['overall_index'] === 0)
        ? getColor('gray')
        : getColor(safety['color_indicator']);
    } else {
      testSrc = `/assets/icons/overview/gray-safety-badge.svg`;
      if (index % 2 === 0) { // Even
        color = getColor("green")
      } else { // Odd
        color = getColor("gray")
      }
    }

    setImageSrc(testSrc);
    setMainbgColor(color)
  }, [props]);

  const start = cliped ? cliped.start_clip - analyseStart : 0;
  const graphStart = cliped ? cliped.start_clip : analyseStart;
  const segment_start = Number(item.start_marker_at) - (session_type === 'ASYNC' ? 0 : graphStart);
  const segment_end = Number(item.end_marker_at) - (session_type === 'ASYNC' ? 0 : graphStart);
  
  const customData: any = {
    overall_index: immersion.overall_index,
    context_indicator: immersion['context_indicator'],
    safety_index: safety.overall_index > 1 ? safety.overall_index : '--',
    safety_indicator: safety.overall_index > 1 && safety.context_indicator,
    safety_color: safety['color_indicator'],
    color: immersion['color_indicator'],
    type: 'Agenda',
    title: item.marker_title,
    segment_start: UtilService.getTimeLabel(segment_start, 1, session_type === 'ASYNC' ? 0 : start),
    segment_length: UtilService.getTimeLabel(segment_end - segment_start, 1, 0),
    segment_end: UtilService.getTimeLabel(segment_end, 1, session_type === 'ASYNC' ? 0 : start),
    start: Number(item.start_marker_at),
    end: Number(item.end_marker_at),
    length: Number(item.end_marker_at - item.start_marker_at),
    marker_id: item?.marker_id
  };

  const handleModal = async (e: any) => {
    if(isMobile){
      openPopover()
    }else{
      setAnchorEl(e.currentTarget);
      setOverlay(customData);
    }
  };

  const goAnalyzeTab = (segment: any) => {
    dispatch(addOverviewToAnalysisKeyMoment(segment));
    let url = `/creator/experience-manager/analyze/${currentSessionCode}`;
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : {};
    if (!!userData) {
      if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
        url = `/subscriber/creator/experience-manager/analyze/${currentSessionCode}`;
      }
    }
    history.push({
      pathname: url,
    })
  };

  const showSafety = useCallback(() => {
    const length = cliped ? Number(cliped.end_clip - cliped.start_clip) : Number(session_length);
    return UtilService.isShowSafety(session_type, length);
  }, [session_type, session_length, cliped]);

  return (
    <div>
      <div className={classes.root} style={{ backgroundColor: mainbgColor }}
        onClick={(e) => handleModal(e)}
      >
        <div className={classes.valuePanel}>
          <img className={classes.badge} src={imgSrc} alt='Badge' />&nbsp;
          {
            type === 'immersion' &&
            <span className={classes.value}>{immersion['overall_index'] === 0 ? '--' : immersion['overall_index']}</span>
          }
          {
            (type === 'safety' && showSafety() && safety['overall_index'] > 1) &&
            <span className={classes.value}>{ safety['overall_index'] }</span>
          }
        </div>
        <div className={classes.textPanel}>
          <span className={clsx(classes.text, 'line-clamp')}>{item.marker_title}</span>
        </div>
      </div>

      {overlay && <AnalyzeKeyMomentPopOut
        anchorEl={anchorEl}
        overlay={overlay}
        setAnchorEl={setAnchorEl}
        goAnalyzeTab={goAnalyzeTab}
        overview={true}
      />}

    </div>
  )
};

export default AgendaItem;